/* Бейдж статуса и пометки вроде «обязательно». */

.root {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 4px 10px;
	border-radius: var(--Border-radius-XXS);
	font-size: 12px;
	font-weight: 500;
	line-height: 150%;
	white-space: nowrap;
}

.neutral {
	background: var(--bg-dark-quartiary);
	color: var(--text-secondary);
}

.accent {
	background: var(--bg-accent-tertiary);
	color: var(--text-accent);
}

.success {
	background: var(--bg-success-tertiary);
	color: var(--text-success);
}

.warning {
	background: var(--bg-warning-tertiary);
	color: var(--text-warning-accent);
}

.error {
	background: var(--bg-error-quartiary);
	color: var(--text-error);
}

/*
 * flex: 0 0 auto обязателен. Тег бывает растянут по ширине колонки, и если места
 * не хватает, недостачу поглощает единственный, кто умеет сжиматься, — точка:
 * из кружка 6px она превращается в 2px и выглядит раздавленной, тогда как текст
 * рядом остаётся целым. Понять по такой строке, что виновата ширина колонки,
 * невозможно — кажется, что сломался сам тег.
 */
.dot {
	flex: 0 0 auto;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: currentColor;
}
